import {AssertUtils,QueryCommand} from 'goingutils';

let dropCodingFactory = (function () {
    let dropItem = {};
    let dropValueItems = {};
    let _loadDateFlag = {};
    let codingMapping = {};
    let idsAry = [];
    let valueCovertDataJson = {};
    let staticCodingJson = {};
    let jsonInfo = {};
    //从缓存中获取值集的真实值
    let setItemValue = function (tdObj, dataType, dropCoding) {

        let newDropCoding = $.trim((dropCoding + "").replaceAll(" ", "&"));
        let itemValue = dropItem[$.trim(_getUrlLastName(dataType)) + "_" + newDropCoding];
        if (itemValue != null && itemValue !== "") {
            tdObj.html(itemValue);
        } else {
            tdObj.html(dropCoding);
        }
    };
    //对值集内容进行缓存
    let _initFactoryItemVaue = function (dataAry, dataType) {
        valueCovertDataJson[dataType] = dataAry;
        //循环ds的每行数据
        dataAry&&AssertUtils.isArray(dataAry)&&dataAry.forEach(function (item) {
            let {value, name} = item;
            //缓存value和name的映射
            dropItem[$.trim(_getUrlLastName(dataType)) + "_" + $.trim(value)] = name;
            //缓存name和value的映射
            dropValueItems[$.trim(_getUrlLastName(dataType)) + "_" + $.trim(name)] = value;
        });
    };
    //获取url最后的参数  目的是为了兼容用户自己定义的url
    let _getUrlLastName = function (codingType) {
        let codingTypeAry = codingType.split("/");
        if (codingTypeAry.length > 1) {
            return codingTypeAry[codingTypeAry.length - 1];
        } else {
            return codingType;
        }
    };
    //加载值集信息
    let loadCodingInfo = function (
        dataType,
        dropCoding,
        tdObj,
        fun,
        loadAryFun
    ) {
        //加载数据完成后的回调函数
        let successFun = function (dataAry) {
            if (dataAry == null) {
                return void 0;
            } else {
                if (loadAryFun != null && AssertUtils.isFunction(loadAryFun)) {
                    loadAryFun(dataAry);
                }
            }
            _loadDateFlag[dataType] = true;
            //对查询的值集数据进行缓存
            _initFactoryItemVaue(dataAry, dataType);
            //进行值集翻译
            if (tdObj != null) {
                setItemValue(tdObj, dataType, dropCoding);
            }
            //如果存在回调函数
            if (AssertUtils.isFunction(fun)) {
                fun(dataAry);
            }
        };
        //需要判断是否为用户自己定义的url 如果不是 直接调用系统的值集查询
        let queryCommand = null;
        if (dataType.indexOf("http") >= 0) {
            queryCommand = new QueryCommand({url:dataType});
        } else {
            queryCommand = new QueryCommand(
                    {url:`${window.SysConfigUtils.go_eplat_adress}${window.projectName.loginDes}/coding/getCodingByTypeCode/`+ dataType}
            );
        }

        queryCommand.showTip = false;
        queryCommand.executeQuery({params: {typeCode:dataType,ids: idsAry.join(";")},successFun});
    };

    //如果是静态下拉  则直接进行值与name的翻译。
    function setStaticCodingValue(tdObj, dataType, dropCoding) {
        let itemValue = staticCodingJson[dataType + "_" + dropCoding];
        if (itemValue != null && itemValue != "") {
            tdObj.html(itemValue);
        } else {
            if (dropCoding == null || dropCoding === "null") {
                tdObj.html("");
            } else {
                tdObj.html(dropCoding);
            }
        }
    }

    let _getCodingMappingVal = function (
        dataType,
        dropCoding,
        tdObj,
        fun
    ) {
        //如果是静态下拉 则通过静态下拉进行翻译 不需要进行查询数据
        if (dataType != null && dataType.indexOf("static_drop_") >= 0) {
            setStaticCodingValue(tdObj, dataType, dropCoding);
        } else {
            let loadDateFlag = _loadDateFlag[dataType];
            //判断该系统下拉是否已经加载数据  如果加载过则进行翻译 如果没有加载过则进行数据加载后再翻译
            if (loadDateFlag) {
                //直接进行翻译操作
                setItemValue(tdObj, dataType, dropCoding);
            } else {
                //加载值集代码
                loadCodingInfo(dataType, dropCoding, tdObj, fun);
            }
        }
    };

    let _getCodingTypeByUrl = function (codingType) {
        if (codingType != null && codingType != "") {
            if (codingType.indexOf("/coding/") >= 0) {
                return _getUrlLastName(codingType);
            }
            return codingType;
        }
        return null;
    };
    return {
        addStaticOptions: function (field, options) {
            //如果是静态下拉   在初始化gridCtl时  如果存在options属性时，会通过该方法将下拉注册成一个系统静态下拉类型
            //翻译时 则不需要进行查询再翻译
            $.each(options, function (key, item) {
                staticCodingJson[
                "static_drop_" + field + "_" + (item["id"] || item["value"])
                    ] = item["text"] || item["label"];
            });
        },
        valueCovertDataJson: function () {
            return valueCovertDataJson;
        },
        getCodingRealValue: function (dataType, codingName) {
            let _selValue = "";
            _selValue = dropValueItems[
            $.trim(_getUrlLastName(dataType)) + "_" + $.trim(codingName)
                ];
            return _selValue;
        },
        getCodingAry(dataType, fun) {
            if (!AssertUtils.isNotNull(dataType)) {
                return void 0;
            }
            //判断缓存中是否存在 如果存在 则直接从缓存中获取
            if (dataType != null && (_loadDateFlag) [dataType]) {
                if (AssertUtils.isFunction(fun)) {
                    let vals = valueCovertDataJson[dataType];
                    fun(vals);
                }
            } else {
                loadCodingInfo(dataType, null, null, null, function (codingAry) {
                    if (AssertUtils.isFunction(fun)) {
                        fun(codingAry);
                    }
                });
            }
        },
        //根据编码的类型  进行系统编码查询 查询完成后将映射关联的json对象返回给回调
        getCodingValue: function (dataType, coding, fun) {
            loadCodingInfo(dataType, null, null, function () {
                if (AssertUtils.isFunction(fun)) {
                    fun(dropItem);
                }
            });
        },
        //grid表格中 先定义一个特殊字符串,后面再通过这个进行替换
        getRelStr: function (value, codingType) {
            if (AssertUtils.isNotEmpty(value)) {
                return (
                    "<div class='codingDrop' value='" +
                    codingType +
                    "#" +
                    value +
                    "' datatype='" +
                    codingType +
                    "'>" +
                    value +
                    "</div>"
                );
            } else {
                return "";
            }
        },
        //获取编码 根据url路径  因为有系统编码 也可能存在用户定义的url
        getCodingTypeByUrl: function (codingUrl) {
            return _getCodingTypeByUrl(codingUrl);
        },
        //根据编码类型  以及编码 设置输入框为编码名称
        getCodingName: function (codingType, coding, elObj) {
            codingType = _getCodingTypeByUrl(codingType);
            _getCodingMappingVal(codingType, coding, elObj);
        },
        //根据下拉的class类名称 进行翻译  主要用于grid表格
        getCodingMappingVal: function () {
            //先将值集进行分组 减少循环的次数
            $(".codingDrop").each(function () {
                let dataType = $(this).attr("datatype");
                let value = $(this).attr("value");
                codingMapping[dataType + "@" + value] = $(this).html();
            });
            //对分组好的值集进行批量翻译
            for (let item in codingMapping) {
                let itemAry = item.split("@");
                if (itemAry.length === 2) {
                    let codingType = itemAry[0];
                    let codingTypeAndValue = itemAry[1];
                    let codingValue = codingTypeAndValue.split("#")[1];
                    _getCodingMappingVal(
                        codingType,
                        codingValue,
                        $(".codingDrop[value='" + codingTypeAndValue + "']").parent()
                    );
                }
            }
        },
        addFieldJson: function (type, json) {
            jsonInfo[type] = json;
        },
        //根据值集的值 进行翻译
        getCodingRelVal: function (_idsAry) {
            idsAry = _idsAry;
            setTimeout(function () {
                dropCodingFactory.getCodingMappingVal();
            }, 100);
        }
    };
})();

export default dropCodingFactory;



// WEBPACK FOOTER //
// ./goingsrc/common/dropCodingFactory.js